export default __webpack_public_path__ + "static/media/parc6.b182f4c5.jpg";